import http from "./http";

const api = {
  getCode(params) {
    return http.post("/bull/cartoon/sendCode", params);
  },
  postLogin(data) {
    return http.post("/bull/cartoon/login", data);
  },
  logout() {
    return http.post("/bull/cartoon/logout");
  },
  // 个人中心
  getUserInfo() {
    return http.post("/bull/cartoon/userCenter");
  },

  // 商品列表
  getGoodsList() {
    return http.post("/bull/cartoon/listSku");
  },
  // 实名认证
  identify(data){
    return http.post("/bull/cartoon/certify",data);
  },
  // 注销账号
   cancelAccount() {
    return http.post("/bull/cartoon/closeAccount");
   }
};

export default api;



// WEBPACK FOOTER //
// ./src/servies/api.js